import request from '../../library/request';
import setGlobalState from '../setGlobalState';

export const getRatings = async (fields) => {
    const res=await request('ratings.getRatings', 'get', '/user/ratings/',fields);
    setGlobalState('ratings.ratings',res?.actions);
};
export const addRating = async (rate) => {
    await request('ratings.addRating', 'post', '/user/rating/',rate);
};